import shipperService from "src/services/shipperService";

export const GET_LIST_SHIPPER = "@shipper/get-list-shipper";
export const GET_LIST_SHIPPER_SUCCESS = "@shipper/get-list-shipper-success";
export const GET_LIST_SHIPPER_FAILURE = "@shipper/get-list-shipper-failure";

export const GET_ONE_SHIPPER = "@shipper/get-one-shipper";
export const GET_ONE_SHIPPER_SUCCESS = "@shipper/get-one-shipper-success";
export const GET_ONE_SHIPPER_FAILURE = "@shipper/get-one-shipper-failure";

export const EDIT_STATUS_SHIPPER = "@shipper/edit-status-shipper";
export const EDIT_STATUS_SHIPPER_FAILURE = "@shipper/edit-status-shipper-failure";

export function editStatusShipperInHouse(id, data) {
  return (dispatch) => {
    try {
      dispatch({
        type: EDIT_STATUS_SHIPPER,
        payload: {
          id,
          data
        }
      });
    } catch (error) {
      dispatch({type: EDIT_STATUS_SHIPPER_FAILURE});
      throw error;
    }
  };
}

export function getListShipperInHouse(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_SHIPPER});
      const response = await shipperService.listShipperInHouse(data);

      dispatch({
        type: GET_LIST_SHIPPER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_SHIPPER_FAILURE});
      throw error;
    }
  };
}

export function getOneShipperInHouse(id, params) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_SHIPPER});
      const response = await shipperService.getOneShipperInHouse(id, params);

      dispatch({
        type: GET_ONE_SHIPPER_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_SHIPPER_FAILURE});
      throw error;
    }
  };
}
